module.exports = __webpack_public_path__ + "static/WEDDING E&M-231-96607ca84a21dd1e035ecfc61b8a665a.jpg";